module.exports = __webpack_public_path__ + "static/img/banner-subscription-near-expired.b21237f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-subscription-near-expired.png
// module id = tN1+
// module chunks = 134